<template>
  <v-container fluid>
    <h2 class="pt-0">DELIVERY</h2>
    <v-divider class="mb-3"></v-divider>
    <v-row no-gutters >
      <v-col cols="12" sm="5" class="pr-1">
        <v-card>
          <v-card-title>{{$t('delivery.states.PREPARING')}}</v-card-title>
          <order-flow-table ref="PREPARING" state="PREPARING"
                            @orderUpdateNext="$refs.READY.fetchOrders()" :show-icons="false"
                            :disable-headers="['orderType','contact.name', 'payment.confirmed','totalAmount','addressOrName','delivery.distance','deliveryUser.username', 'actions']"
          />

        </v-card>
      </v-col>
      <v-col cols="12" sm="7">
        <v-card>
          <v-card-title>{{$t('delivery.states.READY')}}</v-card-title>
          <order-flow-table ref="READY" state="READY"
                            @orderUpdatePrev="$refs.PREPARING.fetchOrders()"  :show-icons="false"
                            :disable-headers="['orderType','contact.name', 'payment.confirmed','totalAmount','addressOrName','delivery.distance', 'actions']"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OrderFlowTable from "@/modules/delivery/components-core/business/OrderFlowTable/OrderFlowTable";


export default {
  name: "OrderFlowDeliveryPage",
  components: {OrderFlowTable},
  mounted() {
    this.$store.dispatch('fetchCategories')
  }
}
</script>

<style scoped>

</style>
